module.exports = __webpack_public_path__ + "static/img/logo.08a4a80b.png";